import * as React from 'react';
import styled from 'styled-components';
import {IconViewList, IconViewShortList, IconViewTiled} from "icons";
import {transition} from "helpers/css";
import {CardView, SelectedViewType, setSelectedView} from "hooks/use-selected-view";

export interface ViewCheckerProps {
  type: SelectedViewType;
  views: CardView[];
  selected: CardView;
  onChange: (selected: CardView) => void;
}

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, max-content);
  gap: 12px;
`;

const Box = styled.div<{active: boolean}>`
  cursor: pointer;
  opacity: ${({active}) => active 
    ? 1 
    : 0.2
  };
  
  ${transition()}
  
  &:hover {
    opacity: ${({active}) => active
      ? 1
      : 0.35
    };
  }
`;

/**
 * This component renders view checker.
 * @return {React.ReactElement}
 * @constructor
 */
export default function ViewChecker(
  props: ViewCheckerProps
):React.ReactElement {
  const [active, setActive] = React.useState<CardView>(props.selected)

  function onChangeHandler(view: CardView) {
    setSelectedView(props.type, view)
    props.onChange(view)
    setActive(view)
  }

  /**
   * render tiled view checker
   * @return {React.ReactElement | void}
   */
  function renderTiledIcon() {
    if (props.views.includes(CardView.Tiled)) {
      return (
        <Box
          active={active === CardView.Tiled}
          onClick={() => onChangeHandler(CardView.Tiled)}
        >
          <IconViewTiled />
        </Box>
      )
    }
  }

  /**
   * render list view checker
   * @return {React.ReactElement | void}
   */
  function renderListIcon() {
    if (props.views.includes(CardView.List)) {
      return (
        <Box
          active={active === CardView.List}
          onClick={() => onChangeHandler(CardView.List)}
        >
          <IconViewList />
        </Box>
      )
    }
  }

  /**
   * render short list view checker
   * @return {React.ReactElement | void}
   */
  function renderShortListIcon() {
    if (props.views.includes(CardView.ShortList)) {
      return (
        <Box
          active={active === CardView.ShortList}
          onClick={() => onChangeHandler(CardView.ShortList)}
        >
          <IconViewShortList />
        </Box>
      )
    }
  }

  return (
    <Container>
      {renderTiledIcon()}
      {renderListIcon()}
      {renderShortListIcon()}
    </Container>
  );
}
